<div #filter class="filter-item-card">
  <div class="box-color box card-box">
    <div class="box-header">
      <h6 class="flex align-items-center"
          (click)="toggleFilterList()"
          [class.text-muted]="!config.filter.length"
          [ngClass]="{'open': !isOpen}">
        <i *ngIf="draggable"
           class="fa fa-sm fa-grip-vertical drag-handle m-r-sm"
           aria-hidden="true"
           [attr.test-id]="'drag-handle' | gpTestId: 'filter-item'"
           (click)="$event.stopPropagation()"
           (mousedown)="dragHandleActive.emit(true)"
           (mouseup)="dragHandleActive.emit(false)"></i>
        <span>
          <ng-container *ngFor="let transIds of config.path; let i = index">
            <ng-container *ngIf="i !== 0">
              {{ transIdsDisplay(transIds) }},
            </ng-container>
          </ng-container>
          <strong>{{ transIdsDisplay(config.transIds) }}</strong>
        </span>
      </h6>
      <div class="box-tool">
        <ul class="nav-item inline">
          <li class="nav-link" *ngIf="toggleable">
            <i class="dropdown-toggle m-r-sm pointer pull-right"
               [ngClass]="{open: isOpen}"
               aria-hidden="true"
               (click)="toggleFilterList()"
               [attr.test-id]="'toogle-filter-list'| gpTestId: 'filter-item'"></i>
          </li>
          <li class="nav-link">
            <i class="fa fa-light fa-trash-can" aria-hidden="true" (click)="removeFilter()"></i>
          </li>
        </ul>
      </div>
    </div>
    <div class="box-body flex flex-column" *ngIf="isOpen">
      <!--Filter field-->
      <ng-container *ngIf="!config.metadatas.disabled">
        <table class="w-100" aria-describedby="conditions">
          <tbody>
          <tr>
            <th></th>
            <td class="text-right">
              <gp-dropdown-select [(ngModel)]="newCondition.sign"
                                  #operation
                                  (click-outside)="operation.open = false"
                                  [direction]="'auto'"
                                  [buttonClasses]="['btn']"
                                  class="add-value-control"
                                  (selected)="addEmptyNotEmptyFilterValue()"
                                  [attr.test-id]="'operator-select'| gpTestId: 'filter-item'"
                                  ngDefaultControl>

                <gp-dropdown-option *ngFor="let sign of conditionalSigns" [ngValue]="sign.value"
                                    [attr.test-id]="'operator-option' | gpTestId: 'filter-item' : sign.value">
                  {{ operation.open ? (sign.display +" "+ getTranslatedSignText(sign.text)) : sign.display }}
                </gp-dropdown-option>
              </gp-dropdown-select>
            </td>
            <td [ngStyle]="computeWidth()">
              <gp-tree-select
                *ngIf="config.fieldType === 'ENTITY'; else dropdown"
                class="form-control"
                [attr.test-id]="'filter-input-entity' | gpTestId: 'filter-item'"
                [url]="config?.metadatas?.rel"
                [responseCallBack]="entityResponseCallback"
                (elementSelected)="addFilterValue()"
                [formControl]="selectedConditionFormControl"
                [isSorted]="true"
                ngDefaultControl>
              </gp-tree-select>

              <ng-template #dropdown>
                <ngx-select *ngIf="shouldShowNgxSelect(newCondition.sign); else inputPanel"
                            name="date"
                            [allowClear]="true"
                            class="entity-list-filter"
                            [formControl]="selectedConditionFormControl"
                            [attr.test-id]="'filter-input' | gpTestId: 'filter-item'"
                            [items]="items"
                            [id]="'entity-list-filter-field-list'"
                            [optionTextField]="'display'"
                            [optionValueField]="'value'"
                            (select)="addFilterValue()"
                            (remove)="removeSelectedCondition()">
                  <ng-template ngx-select-option ngx-select-option-selected let-option>
                    <span>{{option.data.display | translate}}</span>
                  </ng-template>
                </ngx-select>
              </ng-template>

              <ng-template #inputPanel>
                <ng-container [ngSwitch]="config.fieldType">
                  <number-input *ngSwitchCase="isNumberType() ? config.fieldType : ''"
                                [type]="config.fieldType === 'INTEGER' ? 'integer' : 'decimal'"
                                [maxDigits]="config.fieldType === payValueType ? 10 : 2"
                                [classes]="['form-control', 'add-value-control']"
                                [attr.test-id]="'filter-input' | gpTestId: 'filter-item'"
                                (keypress)="handleEnterKeyPress($event)"
                                [(ngModel)]="newCondition.value">
                  </number-input>
                  <datepicker-input *ngSwitchCase="'DATE'"
                                    [isAppendToBody]="true"
                                    [hasEternity]="true"
                                    [attr.test-id]="'filter-input' | gpTestId: 'filter-item'"
                                    [(ngModel)]="newCondition.value">
                  </datepicker-input>
                  <input *ngSwitchDefault
                         type="text"
                         [attr.test-id]="'filter-input' | gpTestId: 'filter-item'"
                         class="form-control add-value-control"
                         (keypress)="handleEnterKeyPress($event)"
                         [(ngModel)]="newCondition.value">
                </ng-container>
              </ng-template>
            </td>
            <td>
              <span>{{config.unitTransId}}</span>
            </td>
            <td class="text-left">
              <button *ngIf="!shouldShowNgxSelect(newCondition.sign)"
                      type="button"
                      class="btn btn-outline-primary add-filter-button add-value-control"
                      [disabled]="!isValidFilterValue()"
                      [attr.test-id]="'add-filter-btn' | gpTestId: 'filter-item'"
                      (click)="addFilterValue()">
                <i class="fa fa-light fa-check" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </ng-container>
      <!--Filter list-->
      <table class="filter-list" aria-describedby="filters">
        <tr *ngIf="!config.filter.length">
          <th></th>
          <td colspan="3" class="text-center"><span>{{'REPORTS.no_values_selected' | translate}}</span></td>
        </tr>
        <tr class="condition" *ngFor="let condition of config.filter">
          <th></th>
          <td class="sign" [tooltip]="getConditionText(condition.sign)">{{ getConditionDisplay(condition.sign) | translate }}</td>
          <td [tooltip]="condition.display" class="value p-b-sm m-b-sm" [attr.test-id]="'filter-value' | gpTestId: 'filter-item'">
            <ng-container [ngSwitch]="config.fieldType">
              <span *ngSwitchCase="isNumberType() ? config.fieldType : ''">
                <ng-container *ngIf="condition.display != null && condition.display !== '' else emptyValue">
                '{{condition.display | gpNumber: config.fieldType === payValueType ? 'DECIMAL_ALL_DIGITS' : 'DECIMAL_2_DIGIT'}}'
                </ng-container>
                <ng-template #emptyValue></ng-template>
              </span>
              <span *ngSwitchCase="'DATE'">
                {{condition.display | gpDate}}
              </span>
              <span *ngSwitchCase="isTranslatableType() ? config.fieldType : ''">
                <ng-container *ngIf="condition.display != null && condition.display !== '' else emptyValue">
                  '{{condition.display | translate}}'
                </ng-container>
                <ng-template #emptyValue></ng-template>
              </span>
              <span *ngSwitchDefault>
                <ng-container *ngIf="condition.display != null && condition.display !== '' else emptyValue">
                  '{{condition.display}}'
                </ng-container>
                <ng-template #emptyValue></ng-template>
              </span>
            </ng-container>
          </td>
          <td *ngIf="!config.metadatas.disabled" class="control">
            <button type="button"
                    class="btn lter"
                    [disabled]="config.metadatas.disabled"
                    [attr.test-id]="'remove-filter-value' | gpTestId: 'filter-item'"
                    (click)="removeValue(condition)">
              <i class="fa fa-light fa-times fa-xs" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </table>


    </div>
  </div>
</div>
